import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";
import ValidatedTextField from "../Inputs/ValidatedTextField";
import { alphaNumericValidator, checkAllValid } from "../../Helpers/ValidationHelpers";

const EditCategoryDialog = ({
	openDialog,
	handleClose,
	initialState,
	rows,
	handleSubmit,
}) => {
	const enqueueSnackbar = useSnackbar();
	const formValid = useRef(null);
	const [fieldData, setFieldData] = useState(null);

	const categoryNames = rows?.map((x) => x.name);

	useEffect(() => {
		if (initialState) {
			setFieldData(initialState);

			formValid.current = {
				name: true,
			};

			return;
		}

		formValid.current = {
			name: false,
		};
	}, [initialState]);

	const handleCloseDialog = () => {
		setFieldData(null);
		handleClose();
	};

	const handleSubmitDialog = () => {
		if (!checkAllValid(formValid.current)) {
			return;
		}

		const nameChanged = initialState?.name !== fieldData.name;
		const oldNameExists = categoryNames.includes(fieldData.name);
		const newNameExists = categoryNames.includes(initialState?.name);

		if (nameChanged && oldNameExists && newNameExists) {
			enqueueSnackbar(
				"Another category with the same name already exists. Choose another name.",
				{
					variant: "error",
					autoHideDuration: 3000,
				}
			);
			return;
		}

		handleSubmit(fieldData);
	};

	return (
		<>
			{fieldData ? (
				<Dialog
					open={openDialog}
					onClose={handleClose}
				>
					<Box
						sx={{
							backgroundColor: (theme) => theme.palette.primary.main,
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							px: 2,
							py: 1,
						}}
					>
						<Typography
							variant='h6'
							sx={{ color: (theme) => theme.palette.primary.contrastText }}
						>
							Edit Category: {initialState?.name}
						</Typography>
						<IconButton
							aria-label='close'
							onClick={handleCloseDialog}
							sx={{
								color: (theme) => theme.palette.primary.contrastText,
							}}
						>
							<CloseIcon />
						</IconButton>
					</Box>
					<>
						<DialogTitle>Edit Category Details</DialogTitle>
						<DialogContent>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 2,
									mt: 2,
								}}
							>
								<ValidatedTextField
									id={"name"}
									label={"Name"}
									helperText={"Name displayed on products and groups"}
									validator={alphaNumericValidator}
									onChange={(isValid) => (formValid.current.name = isValid)}
									setActiveForm={setFieldData}
									initialValue={fieldData.name}
									fieldPath={["name"]}
									required
									infoAdornment={null}
								/>
							</Box>
						</DialogContent>
						<DialogActions sx={{ mb: 1 }}>
							<Button onClick={handleCloseDialog}>Cancel</Button>
							<Button
								onClick={handleSubmitDialog}
								disabled={!checkAllValid(formValid.current)}
								variant={"contained"}
							>
								Submit
							</Button>
						</DialogActions>
					</>
				</Dialog>
			) : null}
		</>
	);
};

export default EditCategoryDialog;
